import { GA4_ID } from "@/lib/config";
import { getVariant } from "@/hooks/useHeroVariant";

export function trackEvent(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;
    const payload = { variant: getVariant(), ...params };
    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  } catch (_e) {
    /* silent */
  }
}

export function trackPageview(path) {
  if (!GA4_ID) return;
  trackEvent("page_view", { page_path: path });
}
